import i18n from '@/i18n';
import Motorcade from './Motorcade';
import Yuntu from './Yuntu';
import Wanjinyou from './Wanjinyou';
import Overview from './Overview';
import Entity from './Entity'; //$IMPORT$
import Lock from './Lock'; //$IMPORT$

export default () => [
  {
    resourceName: i18n.t('electron-index-1992f2b7bde7b977c-1'),
    routerUrl: '/electron',
    resourceIcon: '',
    type: '0',
    buttons: [],
    children: [
      Overview(),
      Motorcade(),
      Yuntu(),
      Entity(), //$MORE$
      Wanjinyou(),
      Lock(),
    ],
  },
];
